import '../../assets/components/Input/InputBox.css';//#region lib/components/Input/InputBox.module.css
var e = "_box_dmigs_2", t = "_boxDisabled_dmigs_26", n = "_boxReadOnly_dmigs_26", r = "_boxActive_dmigs_31", i = "_boxError_dmigs_38", a = "_adornment_dmigs_68", o = "_input_dmigs_97", s = "_textarea_dmigs_118", c = {
	box: e,
	boxDisabled: t,
	boxReadOnly: n,
	boxActive: r,
	boxError: i,
	adornment: a,
	input: o,
	textarea: s
};
//#endregion
export { a as adornment, e as box, r as boxActive, t as boxDisabled, i as boxError, n as boxReadOnly, c as default, o as input, s as textarea };
